import { render, staticRenderFns } from "./agreemenList.vue?vue&type=template&id=c51082f8&"
import script from "./agreemenList.vue?vue&type=script&lang=js&"
export * from "./agreemenList.vue?vue&type=script&lang=js&"
import style0 from "./agreemenList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports